import { useSelector } from "react-redux";
import AsyncSelect from "react-select/async";
import { SearchFieldStyles } from "./SearchFieldStyles";
import servSolicitacaoFiscalizacao from "../../services/login/servSolicitacaoFiscalizacao";

const SolicCompartilhamentoSearchField = ({ field, id, setOpenError, setErrorMessage, disabled = false, className = "" }) => {
  const user = useSelector(state => state.user);

  const loadSolicitacoes = async () => {
    try {
      const response = await servSolicitacaoFiscalizacao.SolicitacoesCompartilhamentoParaFiscalizar(user.codigoUsuario);

      let data = response.Content.map(mapResponseToValuesAndLabels);

      return data;

    } catch (err) {
      setOpenError(true);
      setErrorMessage(err.response.data.Message);
    }
  }

  const mapResponseToValuesAndLabels = (data) => {
    let label = `${data.CodigoVisual} - ${data?.Ocupante?.Nome}`;

    return {
      value: data.Id,
      label: label
    }
  }

  return (
    <AsyncSelect
      id={id}
      cacheOptions
      placeholder="Solicitação de compartilhamento"
      loadOptions={loadSolicitacoes}
      defaultOptions
      isDisabled={!disabled}
      styles={SearchFieldStyles}
      {...field}
      className={className}
    />
  )
}

export { SolicCompartilhamentoSearchField }